export default {
  tooltips: {
    metrics: {
      online: 'Request metrics from the server every 15 seconds'
    }
  }
}
